var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-summary-row as-table"},[_c('div',{staticClass:"c-summary-cell"},[_c('div',{staticClass:"c-list-button c-list-button--plus small",on:{"click":function($event){return _vm.$emit('add')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }